"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var WalletInterface = require('../interface/walletInterface');

var _require = require('../storage'),
    cache = _require.cache;

var util = require('../util');

var Provider = require('../provider');

var LedgerNanoS = require('./ledgerNanoS');

var Ledger = /*#__PURE__*/function (_WalletInterface) {
  _inherits(Ledger, _WalletInterface);

  var _super = _createSuper(Ledger);

  /**
   * Constructor
   * @param {*} net 
   * @param {*} options - extra options for specific wallets
   * getWaiting
   * getApproval
   */
  function Ledger(net, options) {
    var _this;

    _classCallCheck(this, Ledger);

    _this = _super.call(this, net, 'hardwallet');
    /**
     * Init options
     */

    _defineProperty(_assertThisInitialized(_this), "setWallet", function (accOpts, callback) {
      _this.provider = new Provider.HardWallet(_this.net);
      accOpts.waitTransaction = _this.getWaiting;
      accOpts.approveTransaction = _this.getApproval;
      return _this.provider.init(accOpts, function (er, web3) {
        if (er) return callback(er, null);
        _this.web3 = web3;
        return callback(null, web3);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setAccountByLedgerNanoS", function (path, index, callback) {
      var getAddress = function getAddress(dpath, callback) {
        var loadedAddressFromCache = cache.get('ledgerNanoS-address-' + dpath);
        if (loadedAddressFromCache) return callback(null, loadedAddressFromCache);
        return LedgerNanoS.getAddress(dpath, function (er, address) {
          if (er) return callback(er, null);
          cache.set('ledgerNanoS-address-' + dpath, address);
          return callback(null, address);
        });
      };

      var killSession = function killSession() {
        cache.removeAll();
      };

      var account = {
        getAddress: getAddress,
        signTransaction: LedgerNanoS.signTransaction,
        killSession: killSession,
        path: path,
        index: index
      };
      return _this.setWallet(account, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "getAccountsByLedgerNanoS", function (path, limit, page, callback) {
      var done = function done(root) {
        var addresses = util.deriveChild(limit, page, root.publicKey, root.chainCode).map(function (item) {
          cache.set('ledgerNanoS-address-' + util.addDPath(path, item.index), item.address);
          return item.address;
        });
        return callback(null, addresses);
      };

      var loadedRootFromCache = cache.get('ledgerNanoS-root-' + path);
      if (loadedRootFromCache) return done(loadedRootFromCache);
      return LedgerNanoS.getPublickey(path, function (er, root) {
        if (er) return callback(er, null);
        cache.set('ledgerNanoS-root-' + path, root);
        return done(root);
      });
    });

    var getWaiting = options.getWaiting,
        getApproval = options.getApproval;
    if (!getWaiting || !getApproval) throw new Error('Invalid options');
    _this.getWaiting = getWaiting;
    _this.getApproval = getApproval;
    return _this;
  }
  /**
   * @func setWallet
   * (Internal function) Set up coinbase
   * @param {*} accOpts 
   */


  return Ledger;
}(WalletInterface);

module.exports = Ledger;